<template>
    <div class="form-group mt-2">
        <label>{{ tra.course_weeks_number }}</label>
        <select 
            name="course_weeks" 
            :value="courseWeeks"
            @change="$emit('update-course-weeks', $event.target.value)"
            class="form-control rounded-10 border"
            data-live-search="true"
        >
            <option v-for="week_count in weeksCount" :value="week_count" :key="week_count">
                {{ week_count }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: 'CourseWeeksSelector',
    props: {
        courseWeeks: [String, Number],
        weeksCount: Number,
        tra: Object,
    },
    emits: ['update-course-weeks'],
};
</script>